import * as React from "react";
import { FundNameDataCell } from "../FundNameDataCell/FundNameDataCell";
import { AsOfDataCell } from "../AsOfDataCell/AsOfDataCell";


const styles = require('../FundNameRow/FundNameRow.pcss');

interface LProps {
    className?: string;
    name?: string;
    key?: string;
    isin?: string;
    stats?: any;
    translations?: any[];
    isIndex?: boolean;
}

export class SectorBenchmarkRow extends React.Component<LProps, {}>{
    constructor() {
        super();
    }

    render() {
        let { isIndex } = this.props;
        let statistics = this.props.stats,
            benchDataPoints = this.getDataPoints(statistics),
            name = this.translateSectorName(this.props, this.props.translations);
        return (
            <tr className={isIndex ? styles.sector_benchmark : styles.innerHeading}>
                <FundNameDataCell isIndex className={styles.sector_benchmark} name={name} />
                <td> </td>
                {benchDataPoints}
                <td> </td>
            </tr>
        );
    }

    getDataPoints(stats) {
        let group = [];
        if (stats) {
            for (let i = 0; i < 5; i++) {
                group.push(<AsOfDataCell key={i} dataPoint={(stats[i]) ? (stats[i].value.toFixed(1) + '%').replace('.', ',') : ' -- '} />);
            }
        }

        return group;
    }

    translateSectorName(props, translations) {
        let name = props.name;
        for (let i = 0; i < translations.length; i++) {
            if (translations[i][4] && translations[i][3] === props.name) {
                name = translations[i][4];
                break;
            }
        }
        return name;
    }

}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/SectorBenchmarkRow/SectorBenchmarkRow.tsx